var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container p-0"},[_c('div',{staticClass:"main-styles-kendrick",attrs:{"id":"app"}},[_c('NavigationBar'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }